import React from 'react';

import {
  HStack,
  Stack, StackProps, Text, useToast,
} from '@chakra-ui/react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';

import { updatePassword } from 'api/auth';
import { Button, Input } from 'components';
import useUser from 'stores/useUser';
import passwordRecovery from 'validations/passwordRecovery';

export default function Password({ ...rest }: StackProps) {
  const { user, set } = useUser();
  const toast = useToast();
  const form = useForm({
    mode: 'all',
    resolver: passwordRecovery,
  });
  const {
    register, handleSubmit, setError, formState: { dirtyFields }, reset,
  } = form;

  const { mutate, isLoading } = useMutation(updatePassword, {
    onSuccess: ({ data, headers }) => {
      set({ accessCode: null, user: data, token: headers.token });
      reset();
    },
    onError: (error: any) => {
      if (error.errors) {
        error.errors.forEach((err) => {
          if (err.field) {
            setError(err.field, err);
          } else {
            setError(Object.keys(dirtyFields)[0], err);
          }
        });
      } else {
        toast({
          title: 'Ocorreu um erro.',
          description: error.message,
          status: 'error',
          duration: 5000,
          position: 'top-right',
          isClosable: true,
        });
      }
    },
  });

  const onSubmit = (data) => mutate({ id: user?.id, data });

  return (
    <Stack
      maxW="1024px"
      bg="white.default"
      borderRadius={8}
      p={6}
      {...rest}>
      <Text
        variant="mediumBold"
        color="primary.default">Trocar Senha
      </Text>
      <FormProvider {...form}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HStack
            mx={5}
            alignItems="center">
            <HStack width="60%">
              <Stack width="100%">
                <Input
                  isSecure
                  placeholder="***********"
                  label="Senha Atual"
                  {...register('currentPassword')}
                />
                <Input
                  isSecure
                  placeholder="***********"
                  label="Nova senha"
                  {...register('password')}
                />
              </Stack>
              <Input
                viewProps={{
                  alignSelf: 'flex-end',
                }}
                label="Confimar Senha"
                placeholder="***********"
                isSecure
                {...register('passwordConfirmation')}
              />
            </HStack>
            <Button
              isLoading={isLoading}
              type="submit"
              alignSelf="flex-end"
              size="sm"
              variant="primary.blue">
              <Text variant="smallBold">Salvar</Text>
            </Button>
          </HStack>
        </form>
      </FormProvider>
    </Stack>
  );
}
